module.exports = __webpack_public_path__ + "img/chicken-casserole.ba11ff9a.jpg";